import React, {useState} from "react";
import { compose } from "recompose";
import { ModalFooter, Table, ModalBody, Modal, Button } from "reactstrap";
import {
  TableContainer,
  TableDataFetch,
  AddNewButton,
  withTable,
  BulkDeleteButton,
  EditDeleteButtons,
  ViewingRecords,
} from "components/common/Tables/index";
import Page from "components/common/Page";
import { Trans } from "react-i18next";
import { formatDate } from "services/util";
import { Link } from "react-router-dom";
import LoadingMsg from "components/common/LoadingMsg";
import BackButton from "components/refactoring/BackButton";

export const PromocodeList = ({
  selected,
  match,
  url = "core/hesaab-promo-code",
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  setOffset,
  search,
  setSearch,
  isDeleteModalOpen,
  toggleDeleteModal,
  onDeleteItem,
  onDeleted,
  refreshToken,
  readOnly,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const [qrImage, setImage] = useState(null);

  const toggle = () => setIsOpen(!isOpen);

  const onShow = (image) => {
    setImage("/api" + image);
    toggle(); 
  };
  
  return (
  <Page title="Promo Codes" className="inv-table">
    <BackButton/>
    <BulkDeleteButton
      className="float-right mb-3 mx-0"
      toggleModal={toggleDeleteModal}
      selected={selected}
      url={url}
      onDeleted={onDeleted}
      isModalOpen={isDeleteModalOpen}
      readOnly={readOnly}
      disabled
    />
    <AddNewButton
      resource="Promo code"
      match={match}
      className="float-left mb-3 mx-0"
      readOnly={readOnly}
    />
    <TableContainer
      items={data.results}
      ordering={ordering}
      onOrderingChanged={setOrdering}
      selected={selected}
      onSelectedChanged={setSelected}
    >
    {data.loading ? <LoadingMsg/>:
      <Table style={{border: '1px solid #e9ecef'}}>
        <thead>
          <tr>
            <th>
              <Trans>Promo Code</Trans>
            </th>
            <th>
              <Trans>QR</Trans>
            </th>
            <th>
              <Trans>Discount</Trans>
            </th>
            <th>
              <Trans>Expiry Date</Trans>
            </th>
            <th>
              <Trans>Created at</Trans>
            </th>
            <th>
              <Trans>Updated at</Trans>
            </th>
            <th>
              <Trans>Status</Trans>
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.results.map((i) => (
            <tr key={i.id}>
              <td><Trans><Link to={`${match.url}/${i.id}`}>{i.code}</Link></Trans></td>
              <td><img onClick={() => onShow(i.get_image)} style={{cursor: "pointer", maxWidth:50}} src={"/api" + i.get_image || "-"}/></td>
              <td>{i.discount} {i.code_type === "Percent" ? "%" : "SAR"}</td>
              <td>{(i.expiry_date)}</td>
              <td>{formatDate(i.created_at)}</td>
              <td>{formatDate(i.updated_at)}</td>
              <td>
              {i.active ? (
                    <span className="fa fa-check-circle text-success" />
                  ) : (
                    <span className="fa fa-times-circle text-danger" />
                  )}
              </td>
              <td className="text-right edit-btn">
                <EditDeleteButtons
                  url={match.url}
                  id={i.id}
                  onDelete={onDeleteItem}
                  readOnly={readOnly}
                />
              </td>
             
            </tr>
          ))}
        </tbody>
      </Table>
      }
    </TableContainer>
    <TableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
    />
    <ViewingRecords
      offset={offset}
      limit={limit}
      count={data.count}
      className="float-left"
    />
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
      <div className="text-center"><img style={{maxWidth:400}} src={qrImage}/></div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}><Trans>Close</Trans></Button>
      </ModalFooter>
    </Modal>
  </Page>
)};

const enhance = compose(withTable({ limit: 999999 }));

export default enhance(PromocodeList);
